import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ImprovementsConfig } from './improvements-config';
import { SignatureInterceptor } from './signature.interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class ImprovementsConfigModule {
  static forRoot(
    config: ImprovementsConfig
  ): ModuleWithProviders<ImprovementsConfigModule> {
    return {
      ngModule: ImprovementsConfigModule,
      providers: [
        {
          provide: ImprovementsConfig,
          useValue: config,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SignatureInterceptor,
          multi: true,
        },
      ],
    };
  }
}
